exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".taskbar-section {\n  width: 100%;\n  height: 40px;\n  background: #f9f9f9;\n  position: absolute;\n  bottom: 0;\n  top: auto !important;\n  left: 0;\n}\n.app-list {\n  overflow: hidden;\n  height: 40px;\n  cursor: default;\n}\n.app-list .app-item {\n  float: left;\n  height: 40px;\n  min-width: 100px;\n  padding: 0 20px 0 15px;\n  text-align: center;\n  line-height: 40px;\n  font-size: 14px;\n  border-right: 1px solid #e9e9e9;\n  /*color:#fff;*/\n  /*background:#ccc;*/\n  color: #aaa;\n  -webkit-filter: saturate(0.2);\n  -moz-filter: saturate(0.2);\n  -o-filter: saturate(0.2);\n  -ms-filter: saturate(0.2);\n}\n.app-list .app-item.actived {\n  /*background:#4b8de4;*/\n  /*color:#fff;*/\n  color: #111;\n  background: #fff;\n  -webkit-filter: saturate(1);\n  -moz-filter: saturate(1);\n  -o-filter: saturate(1);\n  -ms-filter: saturate(1);\n}\n.app-list .app-item .icon {\n  display: inline-block;\n  width: 25px;\n  height: 25px;\n  margin-right: 5px;\n  background-size: cover;\n  vertical-align: top;\n  position: relative;\n  top: 7px;\n}\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/views/taskbar.vue
 ** module id = 92
 ** module chunks = 0
 **/